module.exports = __webpack_public_path__ + "img/body-position-dropdown.8f86a202.gif";